import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/layout/default.vue'
import blankLayout from '@/layout/blank.vue'
import eventMobileLayout from '@/layout/eventMobile.vue'
import workspaceLayout from '@/layout/workspace.vue'
import { beforeEach } from './guards'

// ========== 新页面 ==========
import home from '../pages/home/home.vue'

// ========== 旧页面（保留兼容） ==========
import scheme from '../views/scheme/index.vue'
import schemeView from '../views/scheme/view.vue'
import service from '../views/service/index.vue'
import serviceProvider from '../views/service-provider/index.vue'
import cooperation from '../views/cooperation/index.vue'
import policy from '../pages/servePolicy/policy.vue'
import serve from '../pages/servePolicy/serve.vue'
import schemeChat from '../views/scheme-chat/index.vue'
import supplierSignatureBasicInfo from '../views/supplier-signature/basic-info.vue'
import supplierSignatureSubmitted from '../views/supplier-signature/submitted.vue'
import supplierSignatureSucceed from '../views/supplier-signature/succeed.vue'
import schemeSignatureBasicInfo from '../views/scheme-signature/basic-info.vue'
import schemeSignatureSubmitted from '../views/scheme-signature/submitted.vue'
import schemeSignatureSucceed from '../views/scheme-signature/succeed.vue'
import supplier from './modules/supplier/index';
import project from './modules/project/index';
import { children as supplyEcosystem } from './modules/supplyEcosystem/index';
import { children as schemeEcosystem } from './modules/schemeEcosystem/index';

const EmptyRouterView = { render: (h) => h('router-view') };

Vue.use(VueRouter)

const routes = [{
  path: '/',
  redirect: '/home',
  component: layout,
  children: [
    // ===== 新首页 =====
    {
      path: 'home',
      name: 'home',
      component: home
    },

    // ===== 新生态详情页（4个） =====
    {
      path: 'ecosystem/partner',
      name: 'ecosystemPartner',
      component: () => import('@/pages/ecosystem/partner/index.vue'),
      meta: { title: '合伙人生态 - 易隆创' }
    },
    {
      path: 'ecosystem/service',
      name: 'ecosystemService',
      component: () => import('@/pages/ecosystem/service/index.vue'),
      meta: { title: '服务能力生态 - 易隆创' }
    },
    {
      path: 'ecosystem/supply',
      name: 'ecosystemSupply',
      component: () => import('@/pages/ecosystem/supply/index.vue'),
      meta: { title: '供应链生态 - 易隆创' }
    },
    {
      path: 'ecosystem/solution',
      name: 'ecosystemSolution',
      component: () => import('@/pages/ecosystem/solution/index.vue'),
      meta: { title: '解决方案生态 - 易隆创' }
    },

    // ===== 新独立页面 =====
    {
      path: 'personas',
      name: 'personas',
      component: () => import('@/pages/personas/index.vue'),
      meta: { title: '合伙人画像 - 易隆创' }
    },
    {
      path: 'join',
      name: 'join',
      component: () => import('@/pages/join/index.vue'),
      meta: { title: '加入流程 - 易隆创' }
    },
    {
      path: 'register',
      name: 'register',
      component: () => import('@/pages/register/index.vue'),
      meta: { title: '注册 - 易隆创', needAuth: true }
    },
    {
      path: 'register/success',
      name: 'registerSuccess',
      component: () => import('@/pages/register/success.vue'),
      meta: { title: '注册成功 - 易隆创' }
    },

    // ===== 旧页面（兼容保留） =====
    {
      path: 'scheme',
      name: 'scheme',
      component: scheme
    }, {
      path: 'scheme/view',
      name: 'schemeView',
      component: schemeView
    }, {
      path: 'scheme/chat',
      name: 'schemeChat',
      component: schemeChat,
      meta: {
        needLogin: true
      }
    }, {
      path: 'service',
      name: 'service',
      component: service
    }, {
      path: 'service-provider',
      name: 'serviceProvider',
      component: serviceProvider
    }, {
      path: 'cooperation',
      name: 'cooperation',
      component: cooperation
    }, {
      path: 'servePolicy/policy',
      name: 'policy',
      component: policy
    }, {
      path: 'servePolicy/serve',
      name: 'serve',
      component: serve
    }, {
      path: 'supplier-signature/basic-info',
      name: 'supplierSignatureBasicInfo',
      component: supplierSignatureBasicInfo,
    }, {
      path: 'supplier-signature/submitted',
      name: 'supplierSignatureSubmitted',
      component: supplierSignatureSubmitted,
    }, {
      path: 'supplier-signature/succeed',
      name: 'supplierSignatureSucceed',
      component: supplierSignatureSucceed,
    }, {
      path: 'supplier-signature/change',
      name: 'supplierSignatureChange',
      component: () => import('../views/supplier-signature/change.vue'),
    }, {
      path: 'scheme-signature/basic-info',
      component: schemeSignatureBasicInfo,
    }, {
      path: 'scheme-signature/submitted',
      component: schemeSignatureSubmitted,
    }, {
      path: 'scheme-signature/succeed',
      component: schemeSignatureSucceed,
    }, {
      path: 'scheme-signature/change',
      component: () => import('../views/scheme-signature/change.vue'),
    }, {
      path: 'ecosystem',
      component: () => import('../views/ecosystem/index.vue'),
    }, {
      path: 'personalInfo',
      name: 'personalInfo',
      component: () => import('../views/personalInfo/change.vue'),
    }]
},

  // ===== 独立页面（无 Navbar/Footer 布局） =====
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login/index.vue'),
    meta: { title: '登录 - 易隆创' }
  },
  {
    path: '/portal',
    name: 'portal',
    component: () => import('@/pages/portal/index.vue'),
    meta: { title: '统一身份中心 - 易隆创', needAuth: true }
  },

  // ===== 工作台 =====
  {
    path: '/workspace',
    component: workspaceLayout,
    redirect: '/workspace/partner',
    meta: { needAuth: true },
    children: [
      {
        path: 'partner',
        name: 'workspacePartner',
        component: () => import('@/pages/workspace/partner/index.vue'),
        meta: { title: '合伙人工作台' }
      },
      {
        path: 'service',
        name: 'workspaceService',
        component: () => import('@/pages/workspace/service/index.vue'),
        meta: { title: '服务商工作台' }
      },
      {
        path: 'supply',
        name: 'workspaceSupply',
        component: () => import('@/pages/workspace/supply/index.vue'),
        meta: { title: '供应商工作台' }
      },
      {
        path: 'solution',
        name: 'workspaceSolution',
        component: () => import('@/pages/workspace/solution/index.vue'),
        meta: { title: '方案商工作台' }
      }
    ]
  },

  // ===== 保留原系统不变 =====
  {
    path: '/supplyEcosystem',
    component: blankLayout,
    children: supplyEcosystem
  }, {
    path: '/schemeEcosystem',
    component: blankLayout,
    children: schemeEcosystem
  }, {
    path: '/scheme-preview',
    name: 'schemePublicPreview',
    component: () => import('../views/schemeEcosystem/pages/ExhibitionPublicPreview.vue'),
    meta: { title: '方案预览', hideGlobalDialogue: true, publicPreview: true }
  }, {
    path: '/event',
    component: eventMobileLayout,
    redirect: '/event/sign-in',
    children: [{
      path: 'sign-in',
      name: 'eventSignIn',
      component: () => import('../views/event/signIn.vue'),
      meta: { title: '活动签到', hideGlobalDialogue: true }
    }, {
      path: 'lottery',
      name: 'eventLottery',
      component: () => import('../views/event/lottery.vue'),
      meta: { title: '幸运抽奖', hideGlobalDialogue: true }
    }, {
      path: 'survey',
      name: 'eventPartnerSurvey',
      component: () => import('../views/event/survey.vue'),
      meta: { title: '合伙人调研问卷', hideGlobalDialogue: true }
    }]
  }, {
    path: '/supplier',
    meta: { title: '供应商' },
    component: EmptyRouterView,
    children: supplier
  }, {
    path: '/project',
    meta: { title: '项目' },
    component: EmptyRouterView,
    children: project
  }]

const router = new VueRouter({
  base: process.env.BASE_URL || '/',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
})

router.beforeEach(beforeEach)

export default router
